import React, { useEffect, useState, useRef } from "react";
import {
  Avatar,
  Box,
  Card,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Menu,
  MenuItem,
  Stack,
  Typography
} from "@mui/material";
import { MoreVert as MoreIcon, LocationOn as MapMarkerIcon } from "@mui/icons-material";
import { useSelector } from "react-redux";
import { FETCH_PROJECTS_PICTURES, FETCH_USERS_WORK_HISTORY } from "../../constant/Apipath";
import { Postrequestcall } from "../../request/Postrequest";
import Loader from "../../common/Loader";
import { useNavigate } from "react-router-dom";
import { BIGrey, BIRed } from "../../assets/helpers";
import SearchField from "../common/SearchField";
import PlaceholderImg from "../../assets/images/placeholder_img.jpg";
import { useDispatch } from "react-redux";
import { setShowReport } from "../../redux/actions/actions";
import { English } from "../../constant/EnglishFallback";
import Emptydata from "../common/Emptydata";
import InfiniteScroll from "react-infinite-scroll-component";
import defaultProjectImage from "../../assets/images/placeholder_img.jpg";
import Pages from "../../constant/ReportModel";

function TradeProjectSection({ id, scrollId }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { loginData, multiLanguageData, reportSuccess } = useSelector((state) => state?.main);
  const ENGLISH = English.Trades || {};
  const LanguageData = multiLanguageData?.Trades || {};
  const {
    TEXT_NO_RESULTS_FOUND = ENGLISH.TEXT_NO_RESULTS_FOUND,
    BUTTON_REPORT = ENGLISH.BUTTON_REPORT,
    TEXT_SEARCH_THIS_TRADE_PROJECTS = ENGLISH.TEXT_SEARCH_THIS_TRADE_PROJECTS,
    TEXT_PROJECTS = ENGLISH.TEXT_PROJECTS,
    TEXT_TRADE_PROJECTS_DESC = ENGLISH.TEXT_TRADE_PROJECTS_DESC,
    TEXT_NO_PROJECT_FOUND = ENGLISH.TEXT_NO_PROJECT_FOUND
  } = LanguageData;
  const debounceTimeout = useRef(null);
  const [projectData, setProjectData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [moreMenuAnchorEl, setMoreMenuAnchorEl] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [showSearchLoader, setShowSearchLaoder] = useState(false);
  const [hasData, setHasData] = useState(false);
  const [projectDetails, setProjectDetails] = useState([]);
  const [pageNumber, setPageNumber] = useState(1);
  const [allDataLoaded, setAllDataLoaded] = useState(false);

  useEffect(() => {
    if (reportSuccess !== true) getInitialData();
  }, [reportSuccess]);

  const getInitialData = async () => {
    setIsLoading(true);
    await getProjectData(searchTerm, 1, "fristTimeApiCall");
    setIsLoading(false);
  };

  const getProjectData = async (searchTerm, pageNumber, fristTimeApiCall) => {
    try {
      setAllDataLoaded(true);
      const obj = {
        PageNr: pageNumber,
        NrOfRecPerPage: 20,
        FullSearch: searchTerm ?? "",
        IncludeRecordNr: false,
        SearchList: [{ TradeId: id ?? 0 }]
      };
      const res = await Postrequestcall(FETCH_USERS_WORK_HISTORY, obj, loginData?.accessToken);

      let resData = res?.data?.data ?? [];
      const uniqueProjectsMap = new Map();

      // Filter out duplicates by using the projectId as key
      resData?.forEach((project) => {
        if (!uniqueProjectsMap.has(project.projectId)) {
          uniqueProjectsMap.set(project.projectId, project);
        }
      });

      // Convert the unique projects map to an array
      const uniqueProjects = Array.from(uniqueProjectsMap.values());

      // Retrieve Site pictures and assign the first one as the thumbnail
      await Promise.all(
        uniqueProjects.map(async (project) => {
          let imageObj = {
            SearchList: [{ projectId: project.projectId }]
          };
          const imagesRes = await Postrequestcall(
            FETCH_PROJECTS_PICTURES,
            imageObj,
            loginData?.accessToken
          );
          const imagesResData = imagesRes?.data?.data ?? [];
          project.image =
            imagesResData.length > 0 ? imagesResData?.[0].thumbImageUrl : PlaceholderImg;
        })
      );

      if (pageNumber > 1) {
        setTimeout(() => {
          setProjectData((prevProducts) => [...prevProducts, ...uniqueProjects]);
        }, 500);
      } else {
        setProjectData(uniqueProjects);
        if (fristTimeApiCall) {
          setHasData(uniqueProjects?.length > 0);
        }
      }
    } catch (err) {
      console.log("getProjectData-> Error When Getting User Work History: ", err);
    } finally {
      setShowSearchLaoder(false);
      setIsLoading(false);
      setAllDataLoaded(false);
    }
  };

  const handleOpenReportModal = () => {
    setMoreMenuAnchorEl(null);
    let reportObj = {
      showReport: true,
      name: Pages?.tradesProject?.name,
      AppScreenId: Pages?.tradesProject?.id,
      recordId: projectDetails.projectId ?? 0
    };
    console.log("reportObj", reportObj, projectDetails);
    dispatch(setShowReport(reportObj));
  };

  const onItemClick = (item) => {
    navigate(`/project/${item?.projectId}`);
  };

  const increaseOffset = (callback) => {
    setPageNumber((prevPageNr) => prevPageNr + 1);
    callback(pageNumber + 1);
  };

  const NoInformation = () => {
    return (
      <Stack sx={{ height: "100%" }}>
        <Box className="empty-data-card">
          <Emptydata
            icon={<MapMarkerIcon className="emptydata-icon" />}
            firstText={TEXT_NO_PROJECT_FOUND}
          />
        </Box>
      </Stack>
    );
  };

  const renderListing = () => {
    return (
      <Stack sx={{ gap: 1 }} >
        <Typography variant="body1" sx={{ color: "text.secondary" }}>
          {TEXT_TRADE_PROJECTS_DESC}
        </Typography>
        <SearchField
          placeholder={TEXT_SEARCH_THIS_TRADE_PROJECTS}
          value={searchTerm}
          onChange={(value) => {
            setShowSearchLaoder(true);
            const searchValue = value;
            setSearchTerm(searchValue);
            if (debounceTimeout.current) {
              clearTimeout(debounceTimeout.current);
            }
            debounceTimeout.current = setTimeout(() => {
              getProjectData(value, 1);
            }, 1000);
          }}
          onSubmit={() => {
            setShowSearchLaoder(true);
            setShowSearchLaoder(searchTerm);
            getProjectData(searchTerm, 1);
          }}
          size={"small"}
        />
        <Stack spacing={1}>
          {showSearchLoader ? (
            <Stack style={{ padding: "30px" }}>
              <Loader />
            </Stack>
          ) : projectData?.length > 0 ? (
            <>
              <InfiniteScroll
                dataLength={projectData?.length}
                next={async () => {
                  increaseOffset((pageNumber) => {
                    getProjectData(searchTerm, pageNumber);
                  });
                }}
                hasMore={true}
                loader={
                  !allDataLoaded ? null : (
                    <h4 style={{ display: "flex", justifyContent: "center" }}>
                      <Loader />
                    </h4>
                  )
                }
                scrollableTarget={scrollId}>
                <List disablePadding>
                  <Stack sx={{ gap: 1 }} >
                    {projectData.map((item) => (
                      <Card key={item?.id} className="pagelist-content">
                        <ListItem
                          key={item?.id}
                          style={{ padding: "0px" }}
                          secondaryAction={
                            <IconButton
                              onClick={(event) => {
                                setProjectDetails(item);
                                setMoreMenuAnchorEl(event.currentTarget);
                              }}>
                              <MoreIcon />
                            </IconButton>
                          }>
                          <ListItemButton
                            onClick={() => {
                              onItemClick(item);
                            }}>
                            <Avatar
                              variant="rounded"
                              style={{ margin: "5px 15px 5px 5px" }}
                              src={item?.image || defaultProjectImage}
                            />
                            <ListItemText primary={item?.projectName} />
                          </ListItemButton>
                        </ListItem>
                      </Card>
                    ))}
                  </Stack>
                </List>
                <Menu
                  anchorEl={moreMenuAnchorEl}
                  open={Boolean(moreMenuAnchorEl)}
                  onClose={() => setMoreMenuAnchorEl(null)}
                  anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
                  transformOrigin={{ horizontal: "right", vertical: "top" }}>
                  <MenuItem onClick={() => handleOpenReportModal()} style={{ color: BIRed }} dense>
                    {BUTTON_REPORT}
                  </MenuItem>
                </Menu>
              </InfiniteScroll>
            </>
          ) : (
            <Stack sx={{ justifyContent: "center", alignItems: "center" }} direction={"row"} style={{ color: BIGrey, padding: "30px" }}>
              {TEXT_NO_RESULTS_FOUND}
            </Stack>
          )}
        </Stack>
      </Stack>
    );
  };

  return (
    <Box className="main-content-card-list">
      <Card className="pagelist-content" sx={{ p: 2 }}>
        {isLoading ? <Loader /> : hasData ? renderListing() : <NoInformation />}
      </Card>
    </Box>
  );
}

export default TradeProjectSection;

